export default {
  // Navigation menu
  nav: {
    home: 'Home',
    intro: 'Project Introduction',
    market: 'Market Opportunities',
    tech: 'Technical Architecture',
    aiQuant: 'AI Quantitative',
    chainGame: 'Chain Game',
    nft: 'NFT',
    static: 'Revenue Products',
    dynamic: 'Promotion Model',
    roadmap: 'Development Roadmap',
    contact: 'Contact Us'
  },
  // Common
  common: {
    comingSoon: 'Coming Soon',
  },
  // Home page
  home: {
    title: 'Whale Ecosystem',
    subtitle: 'Committed to building a decentralized financial platform that integrates physical computing power anchoring, AI-enhanced quantitative strategies, and community governance',
    intro: {
      title: 'Project Introduction',
      desc: 'Learn about the vision and mission of Whale Ecosystem'
    },
    market: {
      title: 'Market Opportunities',
      desc: 'Explore new trends in the digital asset market'
    },
    tech: {
      title: 'Technical Architecture',
      desc: 'Learn about core technical architecture and security guarantees'
    },
    token: {
      title: 'Token Economy',
      desc: '$TRUMPDOGE Economic Model Explained'
    },
    ecosystem: {
      title: 'Ecosystem Applications',
      desc: 'Powerful revenue sources and ecosystem layout'
    },
    static: {
      title: 'Static Revenue',
      desc: 'Fixed-term lock-up revenue plan'
    },
    dynamic: {
      title: 'Promotion Model',
      desc: 'Dynamic promotion reward mechanism'
    },
    roadmap: {
      title: 'Development Roadmap',
      desc: 'Clear ecosystem development path'
    },
    aiQuant: {
      title: 'AI Quantitative',
      desc: 'AI-enhanced quantitative trading strategies'
    }
  },
  // Contact page
  contact: {
    aboutUs: 'About Us',
    aboutText1: 'Over the past 10 years of development, Liming Software Technology has always adhered to the development philosophy of "Innovation - Rigor - Integrity - Win-Win". We now have excellent cases in many fields, have established partial cooperation relationships with major Internet companies, and have successively become strategic partners of many network companies, which is a great affirmation of Liming Software Technology.',
    aboutText2: 'The members of Liming Software Technology Network have long-term industry work experience, bringing together a group of high-quality customer management personnel and experienced technical personnel, and attracting a group of outstanding young people in the industry. They come from the forefront of IT technology and creative arts, full of creativity and dedication, which is the prerequisite guarantee for Liming Software Technology Network\'s leadership and an important asset of Liming Software Technology.',
    corporate: 'Corporate Culture',
    vision: 'Vision',
    visionText: 'Liming Software Technology is committed to becoming a leader in the domestic IT technology services and industry solutions market.',
    mission: 'Mission',
    missionText: 'Liming Software has always adhered to creating more value for customers with innovative ideas and leading technology.',
    values: 'Values',
    valuesText: 'Quality, Innovation, Learning, Co-creation and Sharing',
    contactUs: 'Contact Us'
  },
  // Project Introduction
  intro: {
    title: 'Project Introduction',
    content: 'Whale Ecosystem is committed to building a decentralized financial platform that integrates physical computing power anchoring, AI-enhanced quantitative strategies, and community governance. We aim to create a transparent, sustainable digital asset value-added ecosystem with strong real revenue capabilities through blockchain technology and innovative token economic models. The platform token $TRUMPDOGE serves as the core carrier of ecosystem value, sharing the long-term dividends of ecosystem development.'
  },
  // Development Roadmap
  roadmap: {
    title: 'Development Roadmap',
    description: 'Our development path is clear, aiming to steadily achieve the ecosystem vision.',
    phase1: {
      title: 'Phase 1.0 (Completed)',
      content: 'Complete the integration of computing power and AI trading core modules, realize U withdrawal and platform coin exchange.'
    },
    phase2: {
      title: 'Phase 2.0 (In Progress)',
      content: 'Build a million-user community and strengthen token holder consensus.'
    },
    phase3: {
      title: 'Phase 3.0 (Future)',
      content: 'Promote $TRUMPDOGE to land on global first-tier exchanges and share the wealth feast with mainstream currencies.'
    },
    phase4: {
      title: 'Phase 4.0 (Future)',
      content: 'Develop and integrate diversified ecosystem platforms (such as DeFi, NFT, chain games, etc.) to achieve sustained, stable and long-term value appreciation of investment and returns.'
    }
  },
  // Footer
  footer: {
    contactUs: 'Contact Us',
    contactEmail: 'Contact Email'
  },
  // Market Opportunities
  market: {
    title: 'Market Background and Opportunities',
    intro: 'The current digital asset market is undergoing profound changes, showing new trends:',
    feature1: {
      title: 'Institutionalization and Diversification',
      content: 'After mainstream assets like Bitcoin hit new highs, some crypto whales have begun to diversify their portfolios, seeking more promising opportunities. This has created a development window for emerging projects with innovative models and real value support.'
    },
    feature2: {
      title: 'Integration of AI and Prediction Markets',
      content: 'AI prediction market models are reshaping related fields, processing market information through algorithms, optimizing liquidity, and providing dynamic pricing, which provides technical reference for improving the efficiency and transparency of platform strategies.'
    },
    feature3: {
      title: 'Real Revenue Demand',
      content: 'Investors increasingly favor revenue models supported by real business income and physical assets, rather than relying entirely on token inflation incentives.'
    }
  },
  // Technical Architecture
  tech: {
    title: 'Core Technical Architecture',
    intro: 'Our technology stack aims to ensure platform efficiency, security, and scalability.',
    item1: {
      title: 'Hybrid Chain Architecture',
      content: 'Combining the transparency of public chains with the efficient processing capabilities of side chains, ensuring that core asset data is tamper-proof while improving transaction speed and reducing user fees.'
    },
    item2: {
      title: 'Modular Smart Contracts',
      contract1: 'Revenue Distribution Contract: Automatically executes static revenue and dynamic promotion rewards, ensuring transparent rules and accurate distribution.',
      contract2: 'AI Strategy Vault Contract: Manages user-invested assets, executes preset AI quantitative and high-frequency trading strategies, and automatically distributes profits.',
      contract3: 'Token Burn Contract: All platform coin sell transactions will be automatically burned, token data is permanently verifiable, creating deflationary pressure.'
    },
    item3: {
      title: 'Security and Auditing',
      security1: 'Multi-signature Wallet: Manages platform core assets, any fund movement requires multiple authorization keys, eliminating single-point risks.',
      security2: 'Third-party Smart Contract Audit: Plans to have core contracts audited by well-known security companies in the industry to enhance user trust.'
    }
  },
  // Token Economy
  token: {
    title: 'Token Economic Model ($TRUMPDOGE)',
    intro: '$TRUMPDOGE is the governance and value core of the Whale Ecosystem, and its design follows a sustainable economic model.',
    details1: {
      title: 'Token Details',
      name: 'Name: TrumpDoge',
      symbol: 'Symbol: $TRUMPDOGE',
      supply: 'Total Supply: 210 billion (all produced through staking mining, no pre-mining)'
    },
    details2: {
      title: 'Value Support and Deflation Mechanism',
      mechanism1: 'Profit Buyback and Burn: Part of the net profit from all platform businesses (computing power, AI trading, ecosystem applications) will regularly buy back and burn $TRUMPDOGE.',
      mechanism2: 'Trade and Burn: All $TRUMPDOGE sell transactions will generate a certain proportion of transaction fees and be directly burned, achieving "sell and deflate", creating infinite deflationary value.',
      mechanism3: 'Staking for Interest: Users can stake $TRUMPDOGE to obtain additional profit dividends, effectively locking liquidity and reducing market selling pressure.'
    },
    details3: {
      title: 'Token Distribution',
      content: '100% produced through participation in platform ecosystem (such as computing power staking, liquidity provision, etc.), ensuring fair community launch.'
    }
  },
  // Ecosystem Applications
  ecosystem: {
    title: 'Ecosystem Applications and Revenue Sources',
    intro: 'Powerful ecosystem applications are the foundation for the platform to generate real revenue and achieve "hematopoiesis".',
    item1: {
      title: 'Physical Computing Power Mining Center',
      content: 'Distribute the revenue from mainstream coins such as BTC, ETH, FIL produced by physical mining farms to users in the form of computing power sales, providing stable underlying revenue.'
    },
    item2: {
      title: 'AI Quantitative and High-Frequency Trading',
      content: 'Professional teams use AI algorithms to conduct high-frequency arbitrage and trend trading on major exchanges, capturing profits from market volatility as an enhanced source of user revenue. This business model is similar to the idea of using algorithms to optimize strategies in AI prediction market models.'
    },
    item3: {
      title: 'Diversified Ecosystem Layout',
      content: 'The business also covers mining machine sales, technical hosting, exchange operations, etc., forming a self-circulating business closed loop.'
    }
  },
  // Static Revenue
  static: {
    title: 'Static Revenue Products',
    intro: 'Users can choose the following plans for investment and enjoy fixed-term lock-up revenue:',
    table: {
      investment: 'Investment Target',
      period: 'Period',
      return: 'Total Return Rate',
      settlement: 'Settlement Method',
      row1: {
        investment: 'BTC / USDT / SHIB / XRP / DOGE etc.',
        period: '360 days',
        return: '300%',
        settlement: 'Principal + Profit'
      },
      row2: {
        investment: 'Platform Token $TRUMPDOGE',
        period: '3 months',
        return: '150%',
        settlement: 'Token-based Settlement'
      },
      row3: {
        investment: 'Platform Token $TRUMPDOGE',
        period: '6 months',
        return: '220%',
        settlement: 'Token-based Settlement'
      },
      row4: {
        investment: 'Platform Token $TRUMPDOGE',
        period: '12 months',
        return: '360%',
        settlement: 'Token-based Settlement'
      }
    },
    note: 'Minimum Investment: 100 USDT or its multiples.'
  },
  // Promotion Model
  dynamic: {
    title: 'Dynamic Promotion Model',
    intro: 'Users can enjoy profit-sharing rewards from their investment amount by recommending new members to join, with up to 50 levels of community rewards',
    feature1: {
      title: 'Revenue Linked to Own Holdings',
      content: 'Encourage users to reinvest and increase holdings, promoting internal ecosystem circulation.'
    },
    feature2: {
      title: 'Transaction Fees',
      content: 'Withdrawal charges 10% transaction fee, used for ecosystem maintenance and token buyback.'
    },
    feature3: {
      title: 'Institutional Guarantee',
      content: 'The platform promises that the system will never change, protecting member interests.'
    }
  }
}

